import {
	buildP2PSessionCreateBody,
	buildP2PSessionPatchDateBody,
	buildP2PTranscriptionOnlySessionCreateBody,
} from '@/utils/p2pSessionBody';

/** ID sintético para criação PRO sem vínculo a available_date da plataforma. */
export const PRO_UNRESTRICTED_AVAILABLE_DATE_ID = 'pro-unrestricted-schedule';

const PRO_BOOKING_SLOT_DURATION_MINUTES = 50;

const parsePickerDateToLocalParts = (pickerDateDdMmYyyy: string) => {
	const split = pickerDateDdMmYyyy.split('/');
	if (split.length !== 3) return null;

	const day = Number(split[0]);
	const month = Number(split[1]);
	const year = Number(split[2]);

	if (!day || !month || !year) return null;

	return { day, month, year };
};

/** Horários de 00:00 a 23:00 (50 min) para qualquer dia — fluxo PRO full time. */
export const buildUnrestrictedSlotsForPickerDate = (
	pickerDateDdMmYyyy: string,
): AvailableDates.SessionTimeSlot[] => {
	const parts = parsePickerDateToLocalParts(pickerDateDdMmYyyy);
	if (!parts) return [];

	const { day, month, year } = parts;
	const slots: AvailableDates.SessionTimeSlot[] = [];

	for (let hour = 0; hour < 24; hour += 1) {
		const start = new Date(year, month - 1, day, hour, 0, 0, 0);

		const end = new Date(
			start.getTime() + PRO_BOOKING_SLOT_DURATION_MINUTES * 60 * 1000,
		);

		slots.push({
			start_time: start.toISOString(),
			end_time: end.toISOString(),
			available_date_id: PRO_UNRESTRICTED_AVAILABLE_DATE_ID,
		});
	}

	return slots;
};

/** Body mínimo para POST /session (P2P) no fluxo do profissional com agenda livre. */
export const buildProfessionalP2PSessionCreateBody = (params: {
	patientId: string;
	selectedDate: string;
	isOnline: boolean;
	serviceId?: string;
}): Sessions.Create =>
	buildP2PSessionCreateBody({
		...params,
		bypassScheduleConstraints: true,
	});

/** Body mínimo para POST /session (P2P_TRANSCRIPTION_ONLY) no fluxo do profissional. */
export const buildProfessionalP2PTranscriptionOnlySessionCreateBody = (params: {
	patientId: string;
	selectedDate: string;
	serviceId?: string;
}): Sessions.Create =>
	buildP2PTranscriptionOnlySessionCreateBody({
		...params,
		bypassScheduleConstraints: true,
	});

/** Body para PATCH /session/:id/date ao reagendar consulta P2P do profissional. */
export const buildProfessionalP2PSessionPatchDateBody = (params: {
	selectedDate: string;
	availableDateId?: string;
}): Sessions.PatchDate['body'] =>
	buildP2PSessionPatchDateBody({
		...params,
		bypassScheduleConstraints: true,
	});
